import React, { useEffect, useState, createContext } from 'react';
import { v4 as uuid } from '@lukeed/uuid';
import { log } from '../utils/logs';
// import { navigate } from 'gatsby-link';
// import { useGO } from '../hooks/useGO';

export const QuizContext = createContext();

export const QuizContextProvider = ({ children, lastScreenIndex, uid }) => {
  // const emailStep = useGO('5estVc6YQLuZkWjv_-wCcQ', 'noEmailStep', [0, 1]);
  const emailStep = 1;

  const [quizState, setQuizState] = useState({
    currentStep: 1,
    currentScreenIndex: 0,
    lastScreenIndex,
    totalScreens: lastScreenIndex + 1,
    question: '',
    quizUid: uid,
    hideEmailStep: false,
    uid: uuid(),
    answers: {},
  });

  useEffect(() => {
    log('SessionInit', {
      category: `Quiz_${uid}`,
      label: quizState.uid,
    });
    setQuizState(prevState => ({
      ...prevState,
      lastScreenIndex: prevState.lastScreenIndex - emailStep,
      hideEmailStep: emailStep === 1,
    }));
  }, []);

  useEffect(() => {
    const jsonState = window.sessionStorage.getItem(`quiz_${uid}`);
    if (jsonState) {
      const parsedState = JSON.parse(jsonState);
      setQuizState(parsedState);
    }
    const gender = new URLSearchParams(document.location.search).get('gender');
    if (gender) {
      setQuizState(prevState => ({
        ...prevState,
        currentScreenIndex: 1,
        answers: {
          ...prevState.answers,
          gender,
        },
      }));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const jsonState = JSON.stringify(quizState);
    window.sessionStorage.setItem(`quiz_${uid}`, jsonState);
    // if (quizState.currentScreenIndex > quizState.lastScreenIndex) {
    //   navigate(`/quiz/${uid}/overview`);
    // }
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    // eslint-disable-next-line
  }, [quizState, uid]);

  const quizLog = (action, label) => {
    log(action, {
      category: `Quiz_${uid}`,
      label,
    });
  };

  const store = {
    ...quizState,
    nextStep() {
      setQuizState(prevState => ({
        ...prevState,
        currentScreenIndex: prevState.currentScreenIndex + 1,
      }));
    },
    prevStep() {
      setQuizState(prevState => ({
        ...prevState,
        currentScreenIndex: prevState.currentScreenIndex - 1,
      }));
    },
    quizLog,
    submitAnswer(question, answer) {
      setQuizState(prevState => ({
        ...prevState,
        currentScreenIndex: prevState.currentScreenIndex + 1,
        answers: {
          ...prevState.answers,
          [question]: answer,
        },
      }));
    },
    submitAnswers(questions) {
      const newAnswers = questions.reduce((answers, question) => {
        return { ...answers, [question.name]: question.value };
      }, {});
      setQuizState(prevState => ({
        ...prevState,
        currentScreenIndex: prevState.currentScreenIndex + 1,
        answers: {
          ...prevState.answers,
          ...newAnswers,
        },
      }));
    },
  };

  return <QuizContext.Provider value={{ store, setQuizState }}>{children}</QuizContext.Provider>;
};
